module.exports = __webpack_public_path__ + "3838d10b39d7ab1dc646b1e1fe0cfe7d.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/team/team-member-hirsch-1.png
// module id = 657
// module chunks = 0